var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradiantCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6143 0.666656H7.03445C5.44837 0.666656 4.1577 1.95732 4.1577 3.54341C4.1577 3.79557 3.95328 3.99999 3.70112 3.99999C2.11504 3.99999 0.824371 5.29066 0.824371 6.87674V14.4565C0.824371 16.0427 2.11504 17.3333 3.70112 17.3333H11.2809C12.5664 17.3333 13.6478 16.4824 14.0129 15.3158C14.0974 15.0456 14.3311 14.8333 14.6142 14.8333C16.2004 14.8333 17.491 13.5427 17.491 11.9566V3.54341C17.491 1.95732 16.2004 0.666656 14.6143 0.666656ZM15.8244 11.9566C15.8244 12.6238 15.2815 13.1667 14.6143 13.1667C14.3621 13.1667 14.1577 12.9622 14.1577 12.7101V6.87674C14.1577 5.29066 12.867 3.99999 11.281 3.99999H6.28095C6.02879 3.99999 5.82437 3.79557 5.82437 3.54341C5.82437 2.87616 6.3672 2.33332 7.03445 2.33332H14.6142C15.2815 2.33332 15.8244 2.87616 15.8244 3.54341V11.9566Z",
    fill: "url(#paint0_linear_178_520)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_520",
    x1: 0.824371,
    y1: 8.99999,
    x2: 17.491,
    y2: 8.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF67CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFCC67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiantCopy);
export default __webpack_public_path__ + "static/media/gradiant-copy.3ac7d5895189c7dbcceab5d093672429.svg";
export { ForwardRef as ReactComponent };